"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTabsContent = exports.StyledTabsTrigger = exports.StyledTabsList = exports.StyledTabsRoot = void 0;
const RadixTabs = __importStar(require("@radix-ui/react-tabs"));
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledTabsRoot = (0, styled_components_1.default)(RadixTabs.Root) ``;
exports.StyledTabsList = (0, styled_components_1.default)(RadixTabs.List) ``;
exports.StyledTabsTrigger = (0, styled_components_1.default)(RadixTabs.Trigger) `
    position: relative;

    padding: 12px 16px;
    border: none;
    background-color: transparent;

    color: var(--ds-color-metal);
    font-family: var(--ds-font-family);
    font-weight: bold;
    line-height: 1.5rem;
    font-size: 1rem;

    svg {
        fill: var(--ds-icon-color, currentColor);
    }

    // Hover styles
    &:hover {
        background-color: var(--ds-color-grey-5);

        border-radius: var(--ds-border-radius);
    }

    &:focus&:focus {
        // Disable focus ring for mouse click
        box-shadow: none;
    }

    // Focus styles
    &:focus-visible {
        box-shadow: none;

        ::after {
            border-radius: var(--ds-border-radius);
            content: "";
            position: absolute;

            width: 100%;
            height: 100%;

            bottom: 0;
            left: 0;
            right: 0;

            box-shadow: 0 0 0 2px var(--ds-color-white),
                0 0 0 4px var(--ds-color-blue-100);
        }
    }

    // Selected styles
    &[data-state="active"] {
        color: var(--ds-color-blue-100);

        ::before {
            content: "";
            position: absolute;

            width: 100%;
            height: 100%;

            bottom: 0;
            left: 0;
            right: 0;

            box-shadow: inset 0 -5px 0 -1px var(--ds-color-blue-100);
        }
    }
`;
exports.StyledTabsContent = (0, styled_components_1.default)(RadixTabs.Content) ``;
//# sourceMappingURL=Tabs.styles.js.map